import { gql } from '@apollo/client';
export const GET_APPLICATION_VIEW_TABLE_DATA = gql`
  query (
    $filter: ApplicationViewFilter
    $sort: ApplicationViewSort
    $paginator: PaginatorOptions!
  ) {
    programmeChoiceMetadata {
      rpgJoinPhdPartnerList {
        value
        label
      }
      prgCollabPhdPartnerList {
        value
        label
      }
    }

    getGSAssigneeList {
      assigneeList {
        netId
        displayName
      }
    }

    applicationViewsPaginated(
      filter: $filter
      sort: $sort
      paginator: $paginator
    ) {
      data {
        id
        applicationNo
        applicant {
          email
          name {
            givenName
            surname
          }
          identity {
            identityType
            isLocal
            needStudentVisa
          }
          nationality
        }
        programmeChoice {
          entryYear
          studyMode
          department
          programme
          programmeType
          partner {
            university
            universityCategory
            isPolyUHomeUniversity
            proposedChiefSupervisor
            partnerUniversityApplicationNo
          }
          researchArea
          researchAreaBackup
          proposedChiefSupervisor
          proposedChiefSupervisorBackup
          supervisorInvitations {
            key
            value
          }
        }
        hkpfsInformation {
          HKPFSReferenceNumber
          validHKPFSApplication
        }
        distinctiveScholarships {
          fundingSource
        }
        status
        nomination {
          _id
          scholarshipNomination {
            polishStatus
          }
          supervisors {
            type
            netId
            givenName
            surname
            confirmedAsCoSupervisor
          }
          fundings {
            source
            status
            panelRemark
          }
          shouldScholarshipNominationPerformed
          interviewPanel {
            scholarshipInterviewSubmission
          }
          submission {
            submitted
            lastSubmissionTime
          }
        }
        gsDecision {
          assignee
        }

        assessment {
          submissionTime {
            from
            at
          }
        }

        meetConditionCheckModel {
          status
          conditionFulfillingDeadline
          updatedAt
        }
        qualificationCheckModel {
          status
        }
        visaModel {
          status
        }
        offerModel {
          programmeCode
          offerDate
          status
        }
        onlineRegistrationModel {
          studentNumber
          commencementDate
        }
        paymentRecords {
          paymentType
          paymentStatus
          paymentDeadline
          paymentReference
          updatedAt
        }
      }
      paginator {
        total_pages
        count
      }
    }
  }
`;
